// theme.js (MUI v4)
// import { createTheme } from "@material-ui/core/styles";

// const theme = createTheme({
//   palette: {
//     type: "light",

//     // Primary brand color - refined blue palette
//     primary: {
//       main: "#1a73e8",   // More vibrant blue (Google-inspired)
//       light: "#63a4ff",  // Lighter tint
//       dark: "#004bb5",   // Darker shade
//       contrastText: "#ffffff",
//     },

//     // Secondary (complementary orange)
//     secondary: {
//       main: "#f57c00",   // Warm orange as complementary color
//       light: "#ffad42",
//       dark: "#bb4d00",
//       contrastText: "#ffffff",
//     },

//     // Neutral colors
//     grey: {
//       50: "#f8f9fa",
//       100: "#f1f3f4",
//       200: "#e8eaed",
//       300: "#dadce0",
//       400: "#bdc1c6",
//       500: "#9aa0a6",
//       600: "#80868b",
//       700: "#5f6368",
//       800: "#3c4043",
//       900: "#202124",
//     },

//     // Background colors
//     background: {
//       default: "#f8f9fa", // Light grey background
//       paper: "#ffffff",   // Card/paper background
//     },

//     // Text colors
//     text: {
//       primary: "#3c4043",   // Dark grey for primary text
//       secondary: "#5f6368", // Medium grey for secondary text
//       disabled: "#9aa0a6",  // Light grey for disabled text
//       hint: "#9aa0a6",      // Hint text
//     },

//     // Action colors
//     action: {
//       active: "#1a73e8",
//       hover: "rgba(26, 115, 232, 0.08)",
//       selected: "rgba(26, 115, 232, 0.16)",
//       disabled: "rgba(0, 0, 0, 0.26)",
//       disabledBackground: "rgba(0, 0, 0, 0.12)",
//     },

//     // Divider color
//     divider: "#dadce0",
//   },

//   typography: {
//     fontFamily: '"Aptos", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
//     fontSize: 14,
//     h1: { 
//       fontWeight: 600, 
//       fontSize: "2.5rem",
//       lineHeight: 1.2,
//       color: "#202124",
//     },
//     h2: { 
//       fontWeight: 600, 
//       fontSize: "2rem",
//       lineHeight: 1.3,
//       color: "#202124",
//     },
//     h3: { 
//       fontWeight: 600, 
//       fontSize: "1.75rem",
//       lineHeight: 1.3,
//       color: "#202124",
//     },
//     h4: { 
//       fontWeight: 600, 
//       fontSize: "1.5rem",
//       lineHeight: 1.4,
//       color: "#202124",
//     },
//     h5: { 
//       fontWeight: 600, 
//       fontSize: "1.25rem",
//       lineHeight: 1.4,
//       color: "#202124",
//     },
//     h6: { 
//       fontWeight: 500, 
//       fontSize: "1.125rem",
//       lineHeight: 1.4,
//       color: "#3c4043",
//     },
//     subtitle1: {
//       fontSize: "1rem",
//       lineHeight: 1.5,
//       color: "#5f6368",
//     },
//     subtitle2: {
//       fontSize: "0.875rem",
//       lineHeight: 1.5,
//       fontWeight: 500,
//       color: "#5f6368",
//     },
//     body1: { 
//       fontSize: "1rem",
//       lineHeight: 1.5,
//       color: "#3c4043",
//     },
//     body2: { 
//       fontSize: "0.875rem", 
//       lineHeight: 1.5,
//       color: "#5f6368",
//     },
//     button: { 
//       textTransform: "none", 
//       fontWeight: 500, 
//       letterSpacing: "0.25px",
//       fontSize: "0.875rem",
//     },
//     caption: {
//       fontSize: "0.75rem",
//       lineHeight: 1.4,
//       color: "#5f6368",
//     },
//     overline: {
//       fontSize: "0.75rem",
//       fontWeight: 500,
//       letterSpacing: "1px",
//       textTransform: "uppercase",
//       color: "#5f6368",
//     },
//   },

//   shape: {
//     borderRadius: 8,
//   },

//   spacing: 8,

//   overrides: {
//     MuiCssBaseline: {
//       "@global": {
//         body: {
//           backgroundColor: "#f8f9fa",
//           color: "#3c4043",
//           lineHeight: 1.5,
//           letterSpacing: "0.2px",
//           fontSmooth: "always",
//           "-webkit-font-smoothing": "antialiased",
//           "-moz-osx-font-smoothing": "grayscale",
//         },
//         "*": {
//           boxSizing: "border-box",
//         },
//         ".Mui-focused": {
//           outline: "none",
//         },
//       },
//     },
//     MuiPaper: {
//       root: {
//         borderRadius: 8,
//         padding: 12,
//         boxShadow: "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)",
//         transition: "box-shadow 0.2s ease",
//         "&:hover": {
//           boxShadow: "0 1px 3px 0 rgba(60, 64, 67, 0.3), 0 4px 8px 3px rgba(60, 64, 67, 0.15)",
//         },
//       },
//       elevation1: {
//         boxShadow: "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)",
//       },
//       elevation2: {
//         boxShadow: "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 2px 6px 2px rgba(60, 64, 67, 0.15)",
//       },
//       elevation3: {
//         boxShadow: "0 1px 3px 0 rgba(60, 64, 67, 0.3), 0 4px 8px 3px rgba(60, 64, 67, 0.15)",
//       },
//       elevation4: {
//         boxShadow: "0 2px 4px -1px rgba(60, 64, 67, 0.3), 0 4px 12px 2px rgba(60, 64, 67, 0.15)",
//       },
//       elevation8: {
//         boxShadow: "0 4px 8px -2px rgba(60, 64, 67, 0.3), 0 8px 24px 4px rgba(60, 64, 67, 0.15)",
//       },
//     },
//     MuiCard: {
//       root: {
//         borderRadius: 12,
//         overflow: "hidden",
//         transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//         "&:hover": {
//           transform: "translateY(-2px)",
//           boxShadow: "0 4px 12px 0 rgba(60, 64, 67, 0.3), 0 8px 24px 4px rgba(60, 64, 67, 0.15)",
//         },
//       },
//     },
//     MuiCardHeader: {
//       root: {
//         padding: "24px 24px 16px",
//       },
//       title: {
//         fontSize: "1.25rem",
//         fontWeight: 600,
//         color: "#202124",
//       },
//       subheader: {
//         fontSize: "0.875rem",
//         color: "#5f6368",
//       },
//     },
//     MuiCardContent: {
//       root: {
//         padding: "16px 24px 24px",
//         "&:last-child": {
//           paddingBottom: "24px",
//         },
//       },
//     },
//     MuiButton: {
//       root: {
//         borderRadius: 8,
//         fontWeight: 500,
//         height: 40,
//         fontSize: "0.875rem",
//         padding: "0 16px",
//         transition: "all 0.2s ease",
//         boxShadow: "none",
//         "&:hover": {
//           boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)",
//           transform: "translateY(-1px)",
//         },
//         "&.Mui-disabled": {
//           backgroundColor: "#f1f3f4",
//           color: "#9aa0a6",
//         },
//       },
//       contained: {
//         boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)",
//         "&:active": {
//           boxShadow: "none",
//           transform: "translateY(1px)",
//         },
//       },
//       outlined: {
//         borderWidth: 1.5,
//         padding: "0 15px", // Adjust for border width
//         "&:hover": {
//           borderWidth: 1.5,
//         },
//       },
//       text: {
//         padding: "0 8px",
//         "&:hover": {
//           backgroundColor: "rgba(26, 115, 232, 0.08)",
//         },
//       },
//       sizeSmall: {
//         height: 32,
//         fontSize: "0.8125rem",
//         padding: "0 12px",
//       },
//       sizeLarge: {
//         height: 48,
//         fontSize: "1rem",
//         padding: "0 20px",
//       },
//       startIcon: {
//         marginRight: 8,
//         "&$iconSizeSmall": {
//           marginRight: 6,
//         },
//       },
//       endIcon: {
//         marginLeft: 8,
//         "&$iconSizeSmall": {
//           marginLeft: 6,
//         },
//       },
//     },
//     MuiOutlinedInput: {
//       root: {
//         borderRadius: 8,
//         transition: "all 0.2s ease",
//         backgroundColor: "#ffffff",
//         "&:hover $notchedOutline": {
//           borderColor: "#1a73e8",
//           borderWidth: 2,
//         },
//         "&$focused $notchedOutline": {
//           borderColor: "#1a73e8",
//           borderWidth: 2,
//         },
//         "&$error $notchedOutline": {
//           borderColor: "#d93025",
//         },
//       },
//       input: {
//         padding: "12px 14px",
//         fontSize: "0.875rem",
//         height: "auto",
//       },
//       inputMultiline: {
//         padding: "12px 14px",
//       },
//       notchedOutline: {
//         borderColor: "#dadce0",
//         transition: "border-color 0.2s ease",
//       },
//     },
//     MuiInputLabel: {
//       outlined: {
//         transform: "translate(14px, 14px) scale(1)",
//         fontSize: "0.875rem",
//         color: "#5f6368",
//         "&$shrink": {
//           transform: "translate(14px, -6px) scale(0.75)",
//           fontWeight: 500,
//         },
//         "&$error": {
//           color: "#d93025",
//         },
//       },
//     },
//     MuiFormHelperText: {
//       root: {
//         fontSize: "0.75rem",
//         marginTop: 4,
//         lineHeight: 1.2,
//         "&$error": {
//           color: "#d93025",
//         },
//       },
//     },
//     MuiFormControlLabel: {
//       label: {
//         fontSize: "0.875rem",
//         color: "#3c4043",
//       },
//     },
//     MuiCheckbox: {
//       root: {
//         color: "#5f6368",
//         "&:hover": {
//           backgroundColor: "rgba(26, 115, 232, 0.08)",
//         },
//         "&$checked": {
//           color: "#1a73e8",
//         },
//       },
//     },
//     MuiRadio: {
//       root: {
//         color: "#5f6368",
//         "&:hover": {
//           backgroundColor: "rgba(26, 115, 232, 0.08)",
//         },
//         "&$checked": {
//           color: "#1a73e8",
//         },
//       },
//     },
//     MuiSwitch: {
//       root: {
//         width: 42,
//         height: 26,
//         padding: 0,
//         margin: 8,
//       },
//       switchBase: {
//         padding: 1,
//         "&$checked": {
//           transform: "translateX(16px)",
//           color: "#ffffff",
//           "& + $track": {
//             backgroundColor: "#1a73e8",
//             opacity: 1,
//             border: "none",
//           },
//         },
//         "&$focusVisible $thumb": {
//           color: "#1a73e8",
//           border: "6px solid #fff",
//         },
//       },
//       thumb: {
//         width: 24,
//         height: 24,
//       },
//       track: {
//         borderRadius: 26 / 2,
//         border: `1px solid #5f6368`,
//         backgroundColor: "#5f6368",
//         opacity: 0.38,
//         transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1)",
//       },
//     },
//     MuiSelect: {
//       select: {
//         "&:focus": {
//           backgroundColor: "transparent",
//         },
//       },
//     },
//     MuiAppBar: {
//       colorPrimary: {
//         backgroundColor: "#ffffff",
//         color: "#202124",
//         boxShadow: "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)",
//       },
//       colorDefault: {
//         backgroundColor: "#ffffff",
//         color: "#202124",
//         boxShadow: "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)",
//       },
//     },
//     MuiToolbar: {
//       root: {
//         minHeight: 64,
//       },
//       regular: {
//         minHeight: 64,
//       },
//     },
//     MuiTab: {
//       root: {
//         textTransform: "none",
//         fontWeight: 500,
//         fontSize: "0.875rem",
//         minWidth: 72,
//         "&:hover": {
//           color: "#1a73e8",
//         },
//         "@media (min-width: 600px)": {
//           minWidth: 72,
//         },
//       },
//       textColorPrimary: {
//         color: "#5f6368",
//         "&$selected": {
//           color: "#1a73e8",
//         },
//       },
//     },
//     MuiTabs: {
//       indicator: {
//         height: 3,
//         backgroundColor: "#1a73e8",
//       },
//     },
//     MuiLink: {
//       root: {
//         fontWeight: 500,
//         cursor: "pointer",
//         transition: "color 0.2s ease",
//         color: "#1a73e8",
//         "&:hover": {
//           color: "#004bb5",
//           textDecoration: "none",
//         },
//       },
//     },
//     MuiTable: {
//       root: {
//         borderCollapse: "separate",
//         borderSpacing: 0,
//       },
//     },
//     MuiTableHead: {
//       root: {
//         backgroundColor: "#f8f9fa",
//       },
//     },
//     MuiTableCell: {
//       root: {
//         borderBottom: "1px solid #e8eaed",
//         padding: "16px",
//       },
//       head: {
//         fontWeight: 500,
//         color: "#3c4043",
//         fontSize: "0.875rem",
//       },
//       body: {
//         fontSize: "0.875rem",
//         color: "#3c4043",
//       },
//     },
//     MuiTableRow: {
//       root: {
//         "&:hover": {
//           backgroundColor: "rgba(26, 115, 232, 0.04)",
//         },
//       },
//     },
//     MuiTooltip: {
//       tooltip: {
//         borderRadius: 6,
//         padding: "8px 12px",
//         fontSize: "0.75rem",
//         backgroundColor: "#3c4043",
//         color: "#ffffff",
//       },
//       arrow: {
//         color: "#3c4043",
//       },
//     },
//     MuiChip: {
//       root: {
//         borderRadius: 16,
//         fontWeight: 500,
//         fontSize: "0.75rem",
//         height: 24,
//       },
//       colorPrimary: {
//         backgroundColor: "#e8f0fe",
//         color: "#1a73e8",
//       },
//       colorSecondary: {
//         backgroundColor: "#fef7e0",
//         color: "#f57c00",
//       },
//       outlined: {
//         borderWidth: 1,
//       },
//       outlinedPrimary: {
//         borderColor: "#1a73e8",
//         color: "#1a73e8",
//       },
//       outlinedSecondary: {
//         borderColor: "#f57c00",
//         color: "#f57c00",
//       },
//       icon: {
//         fontSize: "0.875rem",
//         marginLeft: 6,
//         marginRight: -4,
//       },
//       avatar: {
//         width: 22,
//         height: 22,
//         fontSize: "0.75rem",
//       },
//       label: {
//         paddingLeft: 8,
//         paddingRight: 8,
//       },
//     },
//     MuiAlert: {
//       root: {
//         borderRadius: 8,
//         padding: "8px 16px",
//       },
//       standardSuccess: {
//         backgroundColor: "#e6f4ea",
//         color: "#137333",
//       },
//       standardInfo: {
//         backgroundColor: "#e8f0fe",
//         color: "#1a73e8",
//       },
//       standardWarning: {
//         backgroundColor: "#fef7e0",
//         color: "#f57c00",
//       },
//       standardError: {
//         backgroundColor: "#fce8e6",
//         color: "#c5221f",
//       },
//       icon: {
//         fontSize: "1.25rem",
//       },
//     },
//     MuiDialog: {
//       paper: {
//         borderRadius: 12,
//       },
//     },
//     MuiDialogTitle: {
//       root: {
//         padding: "24px 24px 16px",
//         fontSize: "1.25rem",
//         fontWeight: 500,
//         color: "#202124",
//       },
//     },
//     MuiDialogContent: {
//       root: {
//         padding: "16px 24px",
//       },
//     },
//     MuiDialogActions: {
//       root: {
//         padding: "16px 24px 24px",
//       },
//     },
//     MuiLinearProgress: {
//       root: {
//         borderRadius: 4,
//         height: 6,
//       },
//       bar: {
//         borderRadius: 4,
//       },
//     },
//     MuiSkeleton: {
//       root: {
//         backgroundColor: "#f1f3f4",
//       },
//     },
//     MuiAccordion: {
//       root: {
//         border: "1px solid #e8eaed",
//         borderRadius: 8,
//         "&:before": {
//           display: "none",
//         },
//         "&$expanded": {
//           margin: 0,
//         },
//       },
//     },
//     MuiAccordionSummary: {
//       root: {
//         padding: "0 24px",
//         minHeight: 64,
//         "&$expanded": {
//           minHeight: 64,
//         },
//       },
//       content: {
//         margin: "16px 0",
//         "&$expanded": {
//           margin: "16px 0",
//         },
//       },
//     },
//     MuiAccordionDetails: {
//       root: {
//         padding: "0 24px 24px",
//       },
//     },
//     MuiAutocomplete: {
//       inputRoot: {
//         "&.MuiOutlinedInput-root": {
//           padding: "4px !important",
//         },
//       },
//       paper: {
//         borderRadius: 8,
//         boxShadow: "0 4px 12px 0 rgba(60, 64, 67, 0.3), 0 8px 24px 4px rgba(60, 64, 67, 0.15)",
//       },
//       option: {
//         fontSize: "0.875rem",
//         minHeight: "auto",
//         padding: "8px 16px",
//         "&[aria-selected='true']": {
//           backgroundColor: "rgba(26, 115, 232, 0.08)",
//         },
//         "&[data-focus='true']": {
//           backgroundColor: "rgba(26, 115, 232, 0.04)",
//         },
//       },
//     },
//   },

//   props: {
//     MuiButton: {
//       color: "primary",
//       disableElevation: true,
//       variant: "contained",
//     },
//     MuiTextField: {
//       variant: "outlined",
//       size: "small",
//     },
//     MuiPaper: {
//       elevation: 1,
//     },
//     MuiCard: {
//       elevation: 1,
//     },
//     MuiAppBar: {
//       elevation: 0,
//     },
//     MuiLink: {
//       underline: "hover",
//     },
//     MuiCheckbox: {
//       color: "primary",
//     },
//     MuiRadio: {
//       color: "primary",
//     },
//     MuiSwitch: {
//       color: "primary",
//     },
//     MuiChip: {
//       size: "small",
//     },
//   },
// });

// export default theme;

// theme.js (MUI v4) with Light/Dark mode
import { createMuiTheme } from "@material-ui/core/styles";

// Light theme colors
const lightPalette = {
  type: "light",
  primary: {
    main: "#1a73e8",
    light: "#63a4ff",
    dark: "#004bb5",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#f57c00",
    light: "#ffad42",
    dark: "#bb4d00",
    contrastText: "#ffffff",
  },
  grey: {
    50: "#f8f9fa",
    100: "#f1f3f4",
    200: "#e8eaed",
    300: "#dadce0",
    400: "#bdc1c6",
    500: "#9aa0a6",
    600: "#80868b",
    700: "#5f6368",
    800: "#3c4043",
    900: "#202124",
  },
  background: {
    default: "#f8f9fa",
    paper: "#ffffff",
  },
  text: {
    primary: "#3c4043",
    secondary: "#5f6368",
    disabled: "#9aa0a6",
    hint: "#9aa0a6",
    night: "#4338ca",
    longDay: "#059669",
    notAvailable: "#dc2626",
    earLy: "#ea580c",
    late: "#ca8a04",
    twiLight: "#7c3aed",
  },
  action: {
    active: "#1a73e8",
    hover: "rgba(26, 115, 232, 0.08)",
    selected: "rgba(26, 115, 232, 0.16)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
  divider: "#dadce0",
};

// Dark theme colors with #131e2b
const darkPalette = {
  type: "dark",
  primary: {
    main: "#8ab4f8",
    light: "#aecbfa",
    dark: "#669df6",
    contrastText: "#131e2b",
  },
  secondary: {
    main: "#fbbc04",
    light: "#fde293",
    dark: "#f9ab00",
    contrastText: "#131e2b",
  },
  grey: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5e1",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a",
  },
  background: {
    default: "#131e2b",
    paper: "#1e2a3a",
  },
  text: {
    primary: "#f1f5f9",
    secondary: "#cbd5e1",
    disabled: "#64748b",
    hint: "#64748b",
    night: "#6366f1",
    longDay: "#34d399",
    notAvailable: "#ef4444",
    earLy: "#fb923c",
    late: "#facc15",
    twiLight: "#a78bfa",
  },
  action: {
    active: "#8ab4f8",
    hover: "rgba(138, 180, 248, 0.08)",
    selected: "rgba(138, 180, 248, 0.16)",
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
  },
  divider: "#334155",
};

// Common theme configuration
const commonTheme = {
  typography: {
    fontFamily:
      '"Aptos", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    h1: {
      fontWeight: 600,
      fontSize: "2.5rem",
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      fontSize: "2rem",
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.75rem",
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.4,
    },
    h6: {
      fontWeight: 500,
      fontSize: "1.125rem",
      lineHeight: 1.4,
    },
    subtitle1: {
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    subtitle2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
    },
    button: {
      textTransform: "none",
      fontWeight: 500,
      letterSpacing: "0.25px",
      fontSize: "0.875rem",
    },
    caption: {
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
    overline: {
      fontSize: "0.75rem",
      fontWeight: 500,
      letterSpacing: "1px",
      textTransform: "uppercase",
    },
  },

  shape: {
    borderRadius: 8,
  },

  spacing: 8,
};

// Create theme based on mode
export const createAppTheme = (mode = "light") => {
  const palette = mode === "dark" ? darkPalette : lightPalette;

  return createMuiTheme({
    ...commonTheme,
    palette,
    overrides: {
      MuiCssBaseline: {
        "@global": {
          body: {
            backgroundColor: palette.background.default,
            color: palette.text.primary,
            lineHeight: 1.5,
            letterSpacing: "0.2px",
            fontSmooth: "always",
            "-webkit-font-smoothing": "antialiased",
            "-moz-osx-font-smoothing": "grayscale",
          },
          "*": {
            boxSizing: "border-box",
          },
          ".Mui-focused": {
            outline: "none",
          },
        },
      },
      MuiPaper: {
        root: {
          borderRadius: 8,
          padding: 12,
          boxShadow:
            mode === "light"
              ? "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)"
              : "0 1px 2px 0 rgba(19, 30, 43, 0.3), 0 1px 3px 1px rgba(19, 30, 43, 0.15)",
          transition: "box-shadow 0.2s ease",
          "&:hover": {
            boxShadow:
              mode === "light"
                ? "0 1px 3px 0 rgba(60, 64, 67, 0.3), 0 4px 8px 3px rgba(60, 64, 67, 0.15)"
                : "0 1px 3px 0 rgba(19, 30, 43, 0.3), 0 4px 8px 3px rgba(19, 30, 43, 0.15)",
          },
        },
        elevation1: {
          boxShadow:
            mode === "light"
              ? "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)"
              : "0 1px 2px 0 rgba(19, 30, 43, 0.3), 0 1px 3px 1px rgba(19, 30, 43, 0.15)",
        },
        elevation2: {
          boxShadow:
            mode === "light"
              ? "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 2px 6px 2px rgba(60, 64, 67, 0.15)"
              : "0 1px 2px 0 rgba(19, 30, 43, 0.3), 0 2px 6px 2px rgba(19, 30, 43, 0.15)",
        },
        elevation3: {
          boxShadow:
            mode === "light"
              ? "0 1px 3px 0 rgba(60, 64, 67, 0.3), 0 4px 8px 3px rgba(60, 64, 67, 0.15)"
              : "0 1px 3px 0 rgba(19, 30, 43, 0.3), 0 4px 8px 3px rgba(19, 30, 43, 0.15)",
        },
        elevation4: {
          boxShadow:
            mode === "light"
              ? "0 2px 4px -1px rgba(60, 64, 67, 0.3), 0 4px 12px 2px rgba(60, 64, 67, 0.15)"
              : "0 2px 4px -1px rgba(19, 30, 43, 0.3), 0 4px 12px 2px rgba(19, 30, 43, 0.15)",
        },
        elevation8: {
          boxShadow:
            mode === "light"
              ? "0 4px 8px -2px rgba(60, 64, 67, 0.3), 0 8px 24px 4px rgba(60, 64, 67, 0.15)"
              : "0 4px 8px -2px rgba(19, 30, 43, 0.3), 0 8px 24px 4px rgba(19, 30, 43, 0.15)",
        },
      },
      MuiCard: {
        root: {
          borderRadius: 12,
          overflow: "hidden",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow:
              mode === "light"
                ? "0 4px 12px 0 rgba(60, 64, 67, 0.3), 0 8px 24px 4px rgba(60, 64, 67, 0.15)"
                : "0 4px 12px 0 rgba(19, 30, 43, 0.3), 0 8px 24px 4px rgba(19, 30, 43, 0.15)",
          },
        },
      },
      MuiCardHeader: {
        root: {
          padding: "24px 24px 16px",
        },
        title: {
          fontSize: "1.25rem",
          fontWeight: 600,
          color: palette.text.primary,
        },
        subheader: {
          fontSize: "0.875rem",
          color: palette.text.secondary,
        },
      },
      MuiCardContent: {
        root: {
          padding: "16px 24px 24px",
          "&:last-child": {
            paddingBottom: "24px",
          },
        },
      },
      MuiButton: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
          height: 40,
          fontSize: "0.875rem",
          padding: "0 16px",
          transition: "all 0.2s ease",
          boxShadow: "none",
          "&:hover": {
            boxShadow:
              mode === "light"
                ? "0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)"
                : "0 1px 2px rgba(19, 30, 43, 0.3), 0 1px 3px rgba(19, 30, 43, 0.3)",
            transform: "translateY(-1px)",
          },
          "&.Mui-disabled": {
            backgroundColor: mode === "light" ? "#f1f3f4" : "#1e2a3a",
            color: mode === "light" ? "#9aa0a6" : "#64748b",
          },
        },
        contained: {
          boxShadow:
            mode === "light"
              ? "0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1)"
              : "0 1px 2px rgba(19, 30, 43, 0.3), 0 1px 3px rgba(19, 30, 43, 0.3)",
          "&:active": {
            boxShadow: "none",
            transform: "translateY(1px)",
          },
        },
        outlined: {
          borderWidth: 1.5,
          padding: "0 15px",
          "&:hover": {
            borderWidth: 1.5,
          },
        },
        text: {
          padding: "0 8px",
          "&:hover": {
            backgroundColor:
              mode === "light"
                ? "rgba(26, 115, 232, 0.08)"
                : "rgba(138, 180, 248, 0.08)",
          },
        },
        sizeSmall: {
          height: 32,
          fontSize: "0.8125rem",
          padding: "0 12px",
        },
        sizeLarge: {
          height: 48,
          fontSize: "1rem",
          padding: "0 20px",
        },
        startIcon: {
          marginRight: 8,
          "&$iconSizeSmall": {
            marginRight: 6,
          },
        },
        endIcon: {
          marginLeft: 8,
          "&$iconSizeSmall": {
            marginLeft: 6,
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          borderRadius: 8,
          transition: "all 0.2s ease",
          backgroundColor:
            mode === "light" ? "#ffffff" : palette.background.paper,
          "&:hover $notchedOutline": {
            borderColor: palette.primary.main,
            borderWidth: 2,
          },
          "&$focused $notchedOutline": {
            borderColor: palette.primary.main,
            borderWidth: 2,
          },
          "&$error $notchedOutline": {
            borderColor: "#d93025",
          },
        },
        input: {
          padding: "12px 14px",
          fontSize: "0.875rem",
          height: "auto",
        },
        inputMultiline: {
          padding: "12px 14px",
        },
        notchedOutline: {
          borderColor: mode === "light" ? "#dadce0" : "#334155",
          transition: "border-color 0.2s ease",
        },
      },
      MuiInputLabel: {
        outlined: {
          transform: "translate(14px, 14px) scale(1)",
          fontSize: "0.875rem",
          color: palette.text.secondary,
          "&$shrink": {
            transform: "translate(14px, -6px) scale(0.75)",
            fontWeight: 500,
          },
          "&$error": {
            color: "#d93025",
          },
        },
      },
      MuiFormHelperText: {
        root: {
          fontSize: "0.75rem",
          marginTop: 4,
          lineHeight: 1.2,
          "&$error": {
            color: "#d93025",
          },
        },
      },
      MuiFormControlLabel: {
        label: {
          fontSize: "0.875rem",
          color: palette.text.primary,
        },
      },
      MuiCheckbox: {
        root: {
          color: palette.text.secondary,
          "&:hover": {
            backgroundColor:
              mode === "light"
                ? "rgba(26, 115, 232, 0.08)"
                : "rgba(138, 180, 248, 0.08)",
          },
          "&$checked": {
            color: palette.primary.main,
          },
        },
      },
      MuiRadio: {
        root: {
          color: palette.text.secondary,
          "&:hover": {
            backgroundColor:
              mode === "light"
                ? "rgba(26, 115, 232, 0.08)"
                : "rgba(138, 180, 248, 0.08)",
          },
          "&$checked": {
            color: palette.primary.main,
          },
        },
      },
      MuiSwitch: {
        root: {
          width: 42,
          height: 26,
          padding: 0,
          margin: 8,
        },
        switchBase: {
          padding: 1,
          "&$checked": {
            transform: "translateX(16px)",
            color: "#ffffff",
            "& + $track": {
              backgroundColor: palette.primary.main,
              opacity: 1,
              border: "none",
            },
          },
          "&$focusVisible $thumb": {
            color: palette.primary.main,
            border: "6px solid #fff",
          },
        },
        thumb: {
          width: 24,
          height: 24,
        },
        track: {
          borderRadius: 26 / 2,
          border: `1px solid ${palette.text.secondary}`,
          backgroundColor: palette.text.secondary,
          opacity: 0.38,
          transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1)",
        },
      },
      MuiSelect: {
        select: {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      },
      MuiAppBar: {
        colorPrimary: {
          backgroundColor:
            mode === "light" ? "#ffffff" : "#1e2a3a",
          color: palette.text.primary,
          boxShadow:
            mode === "light"
              ? "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)"
              : "0 1px 2px 0 rgba(19, 30, 43, 0.3), 0 1px 3px 1px rgba(19, 30, 43, 0.15)",
        },
        colorDefault: {
          backgroundColor:
            mode === "light" ? "#ffffff" : "#1e2a3a",
          color: palette.text.primary,
          boxShadow:
            mode === "light"
              ? "0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15)"
              : "0 1px 2px 0 rgba(19, 30, 43, 0.3), 0 1px 3px 1px rgba(19, 30, 43, 0.15)",
        },
      },
      MuiToolbar: {
        root: {
          minHeight: 64,
        },
        regular: {
          minHeight: 64,
        },
      },
      MuiTab: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          fontSize: "0.875rem",
          minWidth: 72,
          "&:hover": {
            color: palette.primary.main,
          },
          "@media (min-width: 600px)": {
            minWidth: 72,
          },
        },
        textColorPrimary: {
          color: palette.text.secondary,
          "&$selected": {
            color: palette.primary.main,
          },
        },
      },
      MuiTabs: {
        indicator: {
          height: 3,
          backgroundColor: palette.primary.main,
        },
      },
      MuiLink: {
        root: {
          fontWeight: 500,
          cursor: "pointer",
          transition: "color 0.2s ease",
          color: palette.primary.main,
          "&:hover": {
            color: mode === "light" ? "#004bb5" : "#aecbfa",
            textDecoration: "none",
          },
        },
      },
      MuiTable: {
        root: {
          borderCollapse: "separate",
          borderSpacing: 0,
        },
      },
      MuiTableHead: {
        root: {
          backgroundColor:
            mode === "light" ? "#f8f9fa" : "#1e2a3a",
        },
      },
      MuiTableCell: {
        root: {
          borderBottom: `1px solid ${palette.divider}`,
          padding: "16px",
        },
        head: {
          fontWeight: 500,
          color: palette.text.primary,
          fontSize: "0.875rem",
        },
        body: {
          fontSize: "0.875rem",
          color: palette.text.primary,
        },
      },
      MuiTableRow: {
        root: {
          "&:hover": {
            backgroundColor:
              mode === "light"
                ? "rgba(26, 115, 232, 0.04)"
                : "rgba(138, 180, 248, 0.04)",
          },
        },
      },
      MuiTooltip: {
        tooltip: {
          borderRadius: 6,
          padding: "8px 12px",
          fontSize: "0.75rem",
          backgroundColor: mode === "light" ? "#3c4043" : "#1e2a3a",
          color: mode === "light" ? "#ffffff" : "#f1f5f9",
        },
        arrow: {
          color: mode === "light" ? "#3c4043" : "#1e2a3a",
        },
      },
      MuiChip: {
        root: {
          borderRadius: 16,
          fontWeight: 500,
          fontSize: "0.75rem",
          height: 24,
        },
        colorPrimary: {
          backgroundColor:
            mode === "light" ? "#e8f0fe" : "rgba(138, 180, 248, 0.16)",
          color: palette.primary.main,
        },
        colorSecondary: {
          backgroundColor:
            mode === "light" ? "#fef7e0" : "rgba(251, 188, 4, 0.16)",
          color: palette.secondary.main,
        },
        outlined: {
          borderWidth: 1,
        },
        outlinedPrimary: {
          borderColor: palette.primary.main,
          color: palette.primary.main,
        },
        outlinedSecondary: {
          borderColor: palette.secondary.main,
          color: palette.secondary.main,
        },
        icon: {
          fontSize: "0.875rem",
          marginLeft: 6,
          marginRight: -4,
        },
        avatar: {
          width: 22,
          height: 22,
          fontSize: "0.75rem",
        },
        label: {
          paddingLeft: 8,
          paddingRight: 8,
        },
      },
      MuiAlert: {
        root: {
          borderRadius: 8,
          padding: "8px 16px",
        },
        standardSuccess: {
          backgroundColor:
            mode === "light" ? "#e6f4ea" : "rgba(19, 115, 51, 0.16)",
          color: mode === "light" ? "#137333" : "#81c995",
        },
        standardInfo: {
          backgroundColor:
            mode === "light" ? "#e8f0fe" : "rgba(26, 115, 232, 0.16)",
          color: mode === "light" ? "#1a73e8" : "#8ab4f8",
        },
        standardWarning: {
          backgroundColor:
            mode === "light" ? "#fef7e0" : "rgba(245, 124, 0, 0.16)",
          color: mode === "light" ? "#f57c00" : "#fbbc04",
        },
        standardError: {
          backgroundColor:
            mode === "light" ? "#fce8e6" : "rgba(197, 34, 31, 0.16)",
          color: mode === "light" ? "#c5221f" : "#f28b82",
        },
        icon: {
          fontSize: "1.25rem",
        },
      },
      MuiDialog: {
        paper: {
          borderRadius: 12,
        },
      },
      MuiDialogTitle: {
        root: {
          padding: "24px 24px 16px",
          fontSize: "1.25rem",
          fontWeight: 500,
          color: palette.text.primary,
        },
      },
      MuiDialogContent: {
        root: {
          padding: "16px 24px",
        },
      },
      MuiDialogActions: {
        root: {
          padding: "16px 24px 24px",
        },
      },
      MuiLinearProgress: {
        root: {
          borderRadius: 4,
          height: 6,
        },
        bar: {
          borderRadius: 4,
        },
      },
      MuiSkeleton: {
        root: {
          backgroundColor: mode === "light" ? "#f1f3f4" : "#1e2a3a",
        },
      },
      MuiAccordion: {
        root: {
          border: `1px solid ${palette.divider}`,
          borderRadius: 8,
          "&:before": {
            display: "none",
          },
          "&$expanded": {
            margin: 0,
          },
        },
      },
      MuiAccordionSummary: {
        root: {
          padding: "0 24px",
          minHeight: 64,
          "&$expanded": {
            minHeight: 64,
          },
        },
        content: {
          margin: "16px 0",
          "&$expanded": {
            margin: "16px 0",
          },
        },
      },
      MuiAccordionDetails: {
        root: {
          padding: "0 24px 24px",
        },
      },
      MuiAutocomplete: {
        inputRoot: {
          "&.MuiOutlinedInput-root": {
            padding: "4px !important",
          },
        },
        paper: {
          borderRadius: 8,
          boxShadow:
            mode === "light"
              ? "0 4px 12px 0 rgba(60, 64, 67, 0.3), 0 8px 24px 4px rgba(60, 64, 67, 0.15)"
              : "0 4px 12px 0 rgba(19, 30, 43, 0.3), 0 8px 24px 4px rgba(19, 30, 43, 0.15)",
        },
        option: {
          fontSize: "0.875rem",
          minHeight: "auto",
          padding: "8px 16px",
          "&[aria-selected='true']": {
            backgroundColor:
              mode === "light"
                ? "rgba(26, 115, 232, 0.08)"
                : "rgba(138, 180, 248, 0.08)",
          },
          "&[data-focus='true']": {
            backgroundColor:
              mode === "light"
                ? "rgba(26, 115, 232, 0.04)"
                : "rgba(138, 180, 248, 0.04)",
          },
        },
      },
    },
    props: {
      MuiButton: {
        color: "primary",
        disableElevation: true,
        variant: "contained",
      },
      MuiTextField: {
        variant: "outlined",
        size: "small",
      },
      MuiPaper: {
        elevation: 1,
      },
      MuiCard: {
        elevation: 1,
      },
      MuiAppBar: {
        elevation: 0,
      },
      MuiLink: {
        underline: "hover",
      },
      MuiCheckbox: {
        color: "primary",
      },
      MuiRadio: {
        color: "primary",
      },
      MuiSwitch: {
        color: "primary",
      },
      MuiChip: {
        size: "small",
      },
    },
  });
};

// Default export for backward compatibility
export default createAppTheme("light");